module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loading) ? _c('conteudo', {
    attrs: {
      "id": "conteudo"
    }
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar",
    attrs: {
      "name": "titulo"
    }
  }, [_vm._v(_vm._s(_vm.pagina.titulo))])], 1), _c('div', {
    staticClass: "texto",
    attrs: {
      "slot": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.pagina.corpo)
    },
    slot: "content"
  }), _c('footer', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('br'), _c('back-and-share')], 1)]) : _c('conteudo', [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Carregando...")]), _c('div', {
    staticClass: "loading-container conteudo-loading",
    attrs: {
      "slot": "loading"
    },
    slot: "loading"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "subtitulo animated",
    staticStyle: {
      "height": "28px"
    }
  })]), _c('div', {
    staticClass: "texto"
  }, [_c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated three-quarter"
  }), _c('div', {
    staticClass: "paragraph animated middle"
  })]), _c('div', {
    staticClass: "slot"
  }, [_c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated full"
  }), _c('div', {
    staticClass: "paragraph animated three-quarter"
  }), _c('div', {
    staticClass: "paragraph animated middle"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a352152","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Extra.vue
// module id = 480
// module chunks = 0